import React, { useContext } from 'react';
import dynamic from 'next/dynamic';
import { RecommendationContext } from '@com/core/common/contexts/recommendationContext';
import { TModule } from '@com/core/common/types/catalog';
import { reportError } from '@com/core/common/utils/sentry';

const StaticComponent = ({ component }: { component: TModule }): JSX.Element | null => {
    const { recommendedSkus } = useContext(RecommendationContext);

    // Switching logic is on filesystem paths
    // e.g. ./bannerSlider/bannerSlider

    if (component.type === 'recommendedProducts') {
        try {
            const Module = dynamic<{ moduleData: any; recommendedSkus: string[] }>(() =>
                import(`./dynamicProducts/recommendedProducts`),
            );
            return <Module moduleData={component} recommendedSkus={recommendedSkus} />;
        } catch (error) {
            reportError(error, {
                componentStack: `StaticComponent.${component.type}`,
            });
            return null;
        }
    }

    if (component.type === 'productCarousel' || component.type === 'productList') {
        try {
            const Module = dynamic<{ moduleData: any }>(() => import(`./dynamicProducts/dynamicProducts`));
            return <Module moduleData={component} />;
        } catch (error) {
            reportError(error, {
                componentStack: `StaticComponent.${component.type}`,
            });
            return null;
        }
    }

    const Module = dynamic<{ moduleData: any }>((): any => {
        return import(`./${component.type}/${component.type}`).catch(error => {
            reportError(error, {
                componentStack: `StaticComponent.${component.type}`,
            });
            return null;
        });
    });

    if (Module) {
        return <Module moduleData={component} />;
    }
    return null;
};

export default StaticComponent;
